import { Link } from 'react-router-dom';
import { ThemeSwitcher } from '@/components/common/ThemeSwitcher';
import { useAuth } from '@/hooks';
import './layout.css';

export function Header() {
  const { user, isAuthenticated, logout } = useAuth();

  return (
    <header className="bg-surface/90 border-b border-border sticky top-0 z-40 backdrop-blur"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <span className="text-xl font-bold text-primary">ATS</span>
            <span className="text-xl font-bold text-text-primary">CV Checker</span>
            {user?.tier === 'pro' ? (
              <span className="hidden sm:inline-flex tier-badge tier-badge--pro">
                ✦ PRO
              </span>
            ) : (
              <span className="hidden sm:inline-flex tier-badge tier-badge--free">
                Free
              </span>
            )}
          </Link>

          {/* Right section */}
          <div className="flex items-center gap-2">
            {/* User email + logout — desktop only */}
            {isAuthenticated && user && (
              <div className="hidden sm:flex items-center gap-2">
                <span className="text-sm text-text-secondary truncate max-w-[180px]">{user.email}</span>
                <button
                  onClick={logout}
                  className="text-xs text-text-secondary hover:text-error px-2 py-1.5 rounded border border-border hover:border-error transition-colors"
                >
                  Log out
                </button>
              </div>
            )}

            <ThemeSwitcher />
          </div>
        </div>
      </div>
    </header>
  );
}
